module.exports = __webpack_public_path__ + "static/media/cross.57851be6.svg";